import { getContext, setContext } from 'svelte';
import type { ToastMessage } from '../components/ui/toast-types.js';
import type { Router } from './router.js';
import type { AppPersistenceContext, GameSessionFactory, PlatformServices } from './types.js';

export const APP_CONTEXT = Symbol('texas42-app');

export interface DialogRequest {
  id: string;
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onconfirm?: () => void;
  oncancel?: () => void;
}

export interface DrawerRequest {
  id: string;
  title: string;
  content?: string;
}

export interface ToastService {
  show(message: Omit<ToastMessage, 'id'>): void;
  dismiss(id: string): void;
}

export interface DialogService {
  open(request: Omit<DialogRequest, 'id'>): void;
  close(): void;
}

export interface DrawerService {
  open(request: Omit<DrawerRequest, 'id'>): void;
  close(): void;
}

export interface AppContext {
  router: Router;
  repositories: AppPersistenceContext['repositories'];
  persistence: AppPersistenceContext['persistence'];
  matchPersistence: AppPersistenceContext['matchPersistence'];
  writeQueue: AppPersistenceContext['writeQueue'];
  sessionFactory: GameSessionFactory;
  platform: PlatformServices;
  toast: ToastService;
  dialog: DialogService;
  drawer: DrawerService;
}

export function setAppContext(context: AppContext): void {
  setContext(APP_CONTEXT, context);
}

export function getAppContext(): AppContext {
  const context = getContext<AppContext>(APP_CONTEXT);
  if (!context) {
    throw new Error('App context is unavailable. Wrap the tree in AppProviders.');
  }
  return context;
}
